import { render } from "./RadialBarChart.vue?vue&type=template&id=2dfaef1d&ts=true"
import script from "./RadialBarChart.vue?vue&type=script&lang=ts"
export * from "./RadialBarChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__